import { useState, useEffect } from "react";
import axios from "axios";
import LogoFallback from "/assets/img/bubbanlogo.jpg";

export default function VideoPage({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Videos | Bandarban University",
}) {
	const [videos, setVideos] = useState([]);
	const [filteredVideo, setFilteredVideo] = useState([]);
	const [search, setSearch] = useState("");
	const [selectedVideo, setSelectedVideo] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [autoPlay, setAutoPlay] = useState(false);
	// Fetch videos from API (replace with your endpoint)
	const videoPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
				department_id:'0',
			});
			const response = await api.post("/all-videos", payload);
			
			const data = response.data.data || response.data || [];
			const datas = data.slice(0, 50);
			// Loop data (array)
			
			//console.log(data[0]);
			
			setVideos(data);
			setFilteredVideo(datas);
			
			if (data.length > 0) {
			  setSelectedVideo(data[0]);
			  setAutoPlay(false);
			}
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {		
		videoPost();		
	}, []);
	
	useEffect(() => {
		let result = videos;
		if (search) {
			result = result.filter((n) =>
				n.title.toLowerCase().includes(search.toLowerCase())
			);
		  setFilteredVideo(result);
		}		
	}, [search, videos]);
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	
  return (
    <div className="bg-gray-50 text-gray-800">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-700 to-teal-600 text-white py-16 text-center">
        <h1 className="text-4xl font-bold">Video Gallery</h1>
        <p className="mt-2 text-lg opacity-90">
          Explore our latest video content and media highlights.
        </p>
      </section>

      {/* Video Playing Row */}
      <section className="max-w-5xl mx-auto py-12 px-6">
        {selectedVideo ? (
          <div className="aspect-video rounded-xl shadow-lg overflow-hidden">
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${selectedVideo.video_id}`}
              title={selectedVideo.title}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        ) : (
          <p className="text-center text-gray-500">Loading video...</p>
        )}
        {selectedVideo && (
          <div className="mt-4 text-center">
            <h2 className="text-2xl font-semibold">{selectedVideo.title}</h2>
            <p className="text-gray-600 text-sm">
              {new Date(selectedVideo.date).toLocaleDateString()}
            </p>
          </div>
        )}
      </section>

      {/* Recent Video List */}
      <section className="max-w-6xl mx-auto py-12 px-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-bold">Recent Videos</h3>
          <input
            type="text"
            placeholder="Search videos..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border rounded-lg px-4 py-2 w-64 focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        {filteredVideo.length > 0 ? (
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
            {filteredVideo.map((video) => (
              <div
                key={video.id}
                className="bg-white rounded-xl shadow hover:shadow-lg cursor-pointer overflow-hidden"
                onClick={() => setSelectedVideo(video)}
              >
                <div className="aspect-video">
                  <img
                    src={`https://img.youtube.com/vi/${video.video_id}/mqdefault.jpg`}
                    alt={video.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-4">
                  <h4 className="font-semibold text-gray-800 truncate">
                    {video.title}
                  </h4>
                  <p className="text-gray-500 text-sm">
                    {new Date(video.date).toLocaleDateString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center">No videos found.</p>
        )}
      </section>
    </div>
  );
}
